import ROUTER from '@/routes/ROUTER'
import React from 'react'
import { LazyLoadingComponent } from '..'
const ChangeInfomationHistory = React.lazy(
  () => import('@/pages/USER/MyAccount/components/ChangeInfomationHistory')
)
const MyAccount = React.lazy(() => import('@/pages/USER/MyAccount'))
const ChangePassword = React.lazy(() => import('@/features/change-password'))

export const userRoutes = [
  {
    path: ROUTER.LICH_SU_CAP_NHAT_THONG_TIN,
    element: (
      <LazyLoadingComponent>
        <ChangeInfomationHistory />
      </LazyLoadingComponent>
    ),
  },
  {
    path: ROUTER.THONG_TIN_TAI_KHOAN,
    element: (
      <LazyLoadingComponent>
        <MyAccount />
      </LazyLoadingComponent>
    ),
  },
  {
    path: ROUTER.CHANGE_PASSWORD,
    element: (
      <LazyLoadingComponent>
        <ChangePassword />
      </LazyLoadingComponent>
    ),
  },
]
